/**
 * 公共api
 */
export default {
  //登录
  login: "/userLogin/login",
  // 上传文档/图片
  uploadFile: "attachment/uploadFile",
  //上传店铺富文本视频
  uploadRTFVideoFile: "attachment/uploadRTFVideoFile",
}
